<template>
  <div class="mx-auto w-full max-w-7xl px-6" :class="className">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'Container',
    props: {
      className: {
        type: String,
        default: ''
      }
    }
  };
</script>
